import React from "react";
import toastError from "../../errors/toastError";

import Typography from "@material-ui/core/Typography";
import { Button, Divider } from "@material-ui/core";
import LocationOn from "@material-ui/icons/LocationOn";

/**
 * Location message preview. Expects latitude, longitude, and optional label.
 * Body format from API: "lat|long|label" (e.g. "12.124|-86.251|AllExpress CRM")
 */
const LocationPreview = ({ latitude, longitude, description }) => {
  const lat = latitude != null ? String(latitude).trim() : "";
  const lng = longitude != null ? String(longitude).trim() : "";
  const hasCoords = lat !== "" && lng !== "";

  const googleMapsUrl = hasCoords
    ? `https://www.google.com/maps?q=${encodeURIComponent(lat)},${encodeURIComponent(lng)}`
    : null;

  const handleViewMap = () => {
    if (!googleMapsUrl) return;
    try {
      window.open(googleMapsUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      toastError(err);
    }
  };

  const coordsText = hasCoords ? `${lat}, ${lng}` : null;

  return (
    <div
      style={{
        minWidth: "220px",
        maxWidth: "280px",
        overflow: "hidden",
        borderRadius: 8,
        border: "1px solid rgba(0,0,0,0.08)",
        backgroundColor: "rgba(0,0,0,0.03)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          padding: "12px 12px 8px",
          gap: 12,
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 8,
            backgroundColor: "rgba(25, 118, 210, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <LocationOn style={{ fontSize: 28, color: "#1976d2" }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          {description && (
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: 600,
                marginBottom: 4,
                lineHeight: 1.3,
                wordBreak: "break-word",
              }}
            >
              {description.replace(/\\n/g, "\n")}
            </Typography>
          )}
          {coordsText && (
            <Typography
              variant="caption"
              style={{
                color: "rgba(0,0,0,0.6)",
                fontFamily: "monospace",
                display: "block",
              }}
            >
              {coordsText}
            </Typography>
          )}
        </div>
      </div>
      <Divider />
      <div style={{ padding: "6px 12px 10px" }}>
        <Button
          fullWidth
          size="small"
          color="primary"
          variant="outlined"
          onClick={handleViewMap}
          disabled={!googleMapsUrl}
        >
          Visualizar
        </Button>
      </div>
    </div>
  );
};

export default LocationPreview;
